import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/** Redirect to /login if not authenticated. Only owner can access /dashboard and /admin/*. Partners only their portal. */
export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;

  if (!user) {
    return <Navigate to="/login" state={{ from: pathname }} replace />;
  }

  const isAdminRoute = pathname === '/dashboard' || pathname.startsWith('/admin/') || pathname.startsWith('/partners');
  if (isAdminRoute && user.role !== 'owner') {
    if (user.role === 'partner' && user.partnerId != null) return <Navigate to={`/portal/${user.partnerId}`} replace />;
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'partner') {
    const portalMatch = pathname.match(/^\/portal\/(\d+)$/);
    if (portalMatch) {
      const id = Number(portalMatch[1]);
      if (user.partnerId != null && id !== user.partnerId) return <Navigate to={`/portal/${user.partnerId}`} replace />;
    } else if (user.partnerId != null) {
      return <Navigate to={`/portal/${user.partnerId}`} replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  return <>{children}</>;
}
